import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { SaveCancelButtonConfig } from '@models/form/button';

/**
 * Reusable component that is not part of a form.
 */
@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './confirm-cancel.component.html',
  styleUrls: ['./confirm-cancel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCancelComponent {
  @Input()
  public buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig();
  @Input() public disableSubmit = false;
  @Input() public showBlock = false;
  @Output() public emitSubmit = new EventEmitter<void>();

  public submit(): void {
    this.emitSubmit.emit();
  }
}
